<template>
  <div v-if="seat">
    <img :src="drawing" class="seat-drawing">
  </div>
</template>

<style scoped lang="scss">
  .seat-drawing {
    max-width: 100%;
  }
  ::v-deep .v-list-item__title {
    white-space: pre-wrap !important;
  }
</style>

<script>
export default {
  props: {
    seat: Object,
  },
  computed: {
    drawing: function() {
      return `https://seats.rufftuff.com/drawings/${this.seat.Number}.jpg`
    },
  }
}
</script>